export default [
    {
        path: "/app/:userDeptRoleId/news",
        components: {
            default: () => import("../views/news/index.vue")
        },
        name: "news"
    },
    {
        path: "/app/:userDeptRoleId/view-news",
        components: {
            default: () => import("../views/news/index-view.vue")
        },
        name: "myNews"
    },
    {
        path: "/app/:userDeptRoleId/news/detail/:id",
        components: {
            default: () => import("../views/news/index.vue"),
            detail: () => import("../views/news/detail.vue")
        },
        name: "newsDetail"
    },
    {
        path: "/app/:userDeptRoleId/view-news/detail/:id",
        components: {
            default: () => import("../views/news/index.vue"),
            detail: () => import("../views/news/detail-view.vue")
        },
        name: "myNewsDetail"
    },
];



// WEBPACK FOOTER //
// ./src/router/news.js